// @ts-nocheck

import { useEffect, useCallback } from 'react';

import type { Game } from '@shared/types';

import useAxios from '@services/api';

import { GameBuild } from './client.types';

export const useFetchGameDefaults = (name: string) => {
  const { response, error, issueRequest } = useAxios<Game>();

  useEffect(() => {
    void issueRequest({ url: `/games/${name}`, method: 'get' });
  }, [name, issueRequest]);

  return response;
};

export const useFetchGameDefaultsLazy = () => {
  const { response, error, issueRequest, loading } = useAxios<Game>();

  const useFetchGameDefaultsLazy = useCallback((name: string) => {
    void issueRequest({ url: `/games/${name}`, method: 'get' });
  }, [issueRequest]);

  return [response, useFetchGameDefaultsLazy, loading] as const;
};

export const useFetchGameBuild = (gameBuildId: string) => {
  const { response, error, issueRequest, loading } = useAxios<GameBuild>();

  const fetchGameBuild = useCallback(() => {
    if (gameBuildId && gameBuildId !== 'undefined') {
      void issueRequest({ url: `/public/games/build-data/${gameBuildId}`, method: 'get' });
    }
  }, [gameBuildId, issueRequest]);

  // Автоматически делаем запрос при изменении gameBuildId
  useEffect(() => {
    if (gameBuildId && gameBuildId !== 'undefined' && !response) {
      fetchGameBuild();
    }
  }, [gameBuildId, response, fetchGameBuild]);

  return [response, fetchGameBuild, error, loading] as const;
};

export const useCreateGameBuild = () => {
  const { response, error, issueRequest, loading, setLoading } =
    useAxios<GameBuild>();

  const handleSubmit = useCallback(
    (formData: FormData) => {
      setLoading(true);

      return issueRequest({
        method: 'PUT',
        url: '/games/build/mazefree',
        body: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    [issueRequest]
  );

  return [response, handleSubmit, loading];
};

export const useSetActivateGameDate = () => {
  const { response, error, issueRequest } = useAxios<Record<string, never>>();

  const useSetActivateGameDate = useCallback((id: string) => {
    void issueRequest({ url: `/games/keys/${id}`, method: 'put' });
  }, [issueRequest]);

  return [response, useSetActivateGameDate] as const;
};
